export const PAYMENT_IMAGE_FIELD_TYPES = ['IMAGE_FIELD']

export const PAYMENT_FILE_FIELD_TYPES = ['FILE_FIELD']

export const PAYMENT_ATTACHMENT_FIELD_TYPES = [
  ...PAYMENT_IMAGE_FIELD_TYPES,
  ...PAYMENT_FILE_FIELD_TYPES
]

export function isPaymentAttachmentField(field) {
  return PAYMENT_ATTACHMENT_FIELD_TYPES.includes(field?.fieldType)
}

export function extractPaymentAttachmentValues(customFields = []) {
  const fields = Array.isArray(customFields) ? customFields : []

  return fields.reduce(
    (acc, field) => {
      if (PAYMENT_IMAGE_FIELD_TYPES.includes(field?.fieldType)) {
        acc.images.push({
          url: field?.value,
          label: field?.label
        })
      }

      if (PAYMENT_FILE_FIELD_TYPES.includes(field?.fieldType)) {
        acc.files.push({
          url: field?.value,
          label: field?.label
        })
      }

      return acc
    },
    {
      images: [],
      files: []
    }
  )
}
